import { render, staticRenderFns } from "./DetailsNote.vue?vue&type=template&id=de23625e&"
import script from "./DetailsNote.vue?vue&type=script&lang=js&"
export * from "./DetailsNote.vue?vue&type=script&lang=js&"
import style0 from "./DetailsNote.vue?vue&type=style&index=0&id=de23625e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports